import CryptoJS from 'crypto-js'

let kkUtil = {
  getClientType() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("micromessenger") > 0) {
      return "wechat";
    } else if (ua.indexOf("android") > 0) {
      return "android";
    } else if (ua.indexOf("iphone") > 0 || ua.indexOf("ipad") > 0) {
      return "ios";
    } else {
      return "pc";
    }
  },
  getQueryStr(paraName) {
    let query = window.location.search.substring(1);
    if (typeof (query) == "undefined" || query == null || query == "") {
      return false;
    }
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == paraName) {
        return pair[1];
      }
    }
    return false;
  },
  isInWebView() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i) == 'micromessenger') { // 微信浏览器判断
      return false
    } else if (ua.match(/qq/i) == 'qq') { // QQ浏览器判断
      return false
    } else if (ua.match(/weibo/i) == "weibo") {
      return false
    } else {
      if (ua.match(/android/i) != null) {
        return ua.match(/browser/i) == null
      } else if (ua.match(/iphone/i) != null) {
        return ua.match(/safari/i) == null
      } else {
        return (ua.match(/macintosh/i) == null && ua.match(/windows/i) == null)
      }
    }
  },
  inWechatAndQQ() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/i) == 'micromessenger' || (ua.match(/qq/i) == 'qq' && ua.match(/qqbrowser/i) != 'qqbrowser')) { // 微信/qq浏览器判断
      return true;
    }
    return false;
  },
  getDomainFromUrl(url) {
    if (!url || url == "") {
      return "unknow";
    } else {
      let str = url.split("/");
      if (str[2]) {
        return str[2];
      } else {
        return "unknow";
      }
    }
  },
  isEmpty(param) {
    if (param == "undefined" || param == null || param == "null" || param == "") {
      return true;
    }
    return false;
  },
  aesDecrypt(encrypted, key) {
    let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    decrypted = CryptoJS.enc.Utf8.stringify(decrypted);
    return decrypted;
  },
  getJsPath(imgPath) {
    if (imgPath == null) {
      throw "retry";
    }
    let tmpImgPath1 = imgPath;
    let tmpImgPath2 = imgPath;
    let imgKey = tmpImgPath1.substr(5, 24);
    let imgWidth = null;
    if (tmpImgPath2.indexOf('_') != -1) {
      let tmpImgPath2Parts = tmpImgPath2.split("_");
      imgWidth = tmpImgPath2Parts[1];
    }
    let jsPath = '/js/' + imgKey;
    if (imgWidth != null) {
      jsPath = jsPath + '/' + imgWidth;
    }
    jsPath = jsPath + '.js';
    return jsPath;
  }
};

export default kkUtil;



// WEBPACK FOOTER //
// ./src/assets/js/kk-util.js